<div *ngIf="loadWithdraw ; else regresar">
  <mat-spinner *ngIf="showMatProgress" mode="indeterminate" style="margin: 0 auto;"></mat-spinner>
  <div class="row" *ngIf=" !showMatProgress">

    <div class="col-md-4 offset-md-2">
      <button class="btn btn-block" [class.btn-primary]="showTotalWithdraw"
        [class.btn-outline-secondary]="!showTotalWithdraw" (click)="totalWithdraw()">Retiro Total del Ahorro</button>
    </div>

    <div class="col-md-4">
      <button class="btn btn-block" [class.btn-primary]="showParcialWithdraw"
        [class.btn-outline-secondary]="!showParcialWithdraw" (click)="parcialWithdraw()">Retiro
        Parcial del Ahorro</button>
    </div>

  </div>
  <div class="mt-3" *ngIf="showTotalWithdraw && !showMatProgress">

    <app-header headerText="Retiro Total del Ahorro:" [small]="true"></app-header>

    <div class="row" *ngIf="!employeeHasLoans">
      <div class="col-md-4">
        <mat-form-field>
          <span class="matPrefixDisabled" matPrefix>$&nbsp;</span>
          <input matInput placeholder="Total Ahorrado:" [value]="currentSavingTotal | number: '.2-2'" type="string"
            readonly>
        </mat-form-field>
      </div>
      <div class="col-md-4">
        <mat-form-field>
          <span class="matPrefixDisabled" matPrefix>$&nbsp;</span>
          <input matInput placeholder="Rendimiento:" [value]="financialReturn | number: '.2-2'" type="string" readonly>
        </mat-form-field>
      </div>
      <div class="col-md-4">
        <mat-form-field>
          <span class="matPrefixDisabled" matPrefix>$&nbsp;</span>
          <input matInput placeholder="Total Retiro de Caja De Ahorro Permanente:"
            [value]="totalWithdrawSum | number: '.2-2'" type="string" readonly>
        </mat-form-field>
      </div>
    </div>

    <div *ngIf="employeeHasLoans">

      <div class="row">
        <div class="col-md-4">
          <mat-form-field>
            <span class="matPrefixDisabled" matPrefix>$&nbsp;</span>
            <input matInput placeholder="Total Ahorrado:" [value]="currentSavingTotal | number: '.2-2'" type="string"
              readonly>
          </mat-form-field>
        </div>
        <div class="col-md-4">
          <mat-form-field>
            <span class="matPrefixDisabled" matPrefix>$&nbsp;</span>
            <input matInput placeholder="Rendimiento:" [value]="financialReturn | number: '.2-2'" type="string"
              readonly>
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div class="col-md-4">
          <mat-form-field>
            <span class="matPrefixDisabled" matPrefix>$&nbsp;</span>
            <input matInput placeholder="Importe del Préstamo:" [value]="pendingLoanTotal | number: '.2-2'"
              type="string" readonly>
          </mat-form-field>
        </div>
        <div class="col-md-4">
          <mat-form-field>
            <span class="matPrefixDisabled" matPrefix>$&nbsp;</span>
            <input matInput placeholder="Intereses por Pronto Pago:" [value]="prepaymentInterest | number: '.2-2'"
              type="string" readonly>
          </mat-form-field>
        </div>
        <div class="col-md-4">
          <mat-form-field>
            <span class="matPrefixDisabled" matPrefix>$&nbsp;</span>
            <input matInput placeholder="Total a Recibir:" [value]="totalAmountToWithdraw | number: '.2-2'"
              type="string" readonly>
          </mat-form-field>
        </div>
      </div>

    </div>
    <div class="row">
      <div class="col-md-4 offset-md-4">
        <!-- TODO Mostrar confirmación antes de cancelar -->
        <button class="btn btn-block btn-outline-secondary" (click)="cancel(0, null)">Cancelar</button>
      </div>
      <div class="col-md-4">
        <!-- TODO Mostrar Confirmación -->
        <button class="btn btn-block btn-primary" (click)="saveTotalWithdraw()">Retirar</button>
      </div>
    </div>

  </div>
  <div class="mt-3" *ngIf="showParcialWithdraw && !showMatProgress">

    <app-header headerText="Retiro Parcial del Ahorro:" [small]="true"></app-header>

    <div class="row" *ngIf="!employeeHasLoans">
      <div class="col-md-4">
        <mat-form-field>
          <span class="matPrefixDisabled" matPrefix>$&nbsp;</span>
          <input matInput placeholder="Total Ahorrado:" [value]="currentSavingTotal | number: '.2-2'" type="string"
            readonly>
        </mat-form-field>
      </div>
      <div class="col-md-4">
        <mat-form-field>
          <span class="matPrefixDisabled" matPrefix>$&nbsp;</span>
          <input matInput placeholder="Monto a Retirar de la Caja de Ahorro:"
            [ngModel]="withdraw.amountToWithdraw | number: '1.'"
            (ngModelChange)="withdraw.amountToWithdraw=currencyInputChanged($event)" appOnlyNumber
            [allowDecimals]="true" [allowSign]="false" type="text">
        </mat-form-field>
      </div>
    </div>

    <div *ngIf="employeeHasLoans">

      <div class="row">
        <div class="col-md-4">
          <mat-form-field>
            <span class="matPrefixDisabled" matPrefix>$&nbsp;</span>
            <input matInput placeholder="Total AhorradoParc:" [value]="currentSavingTotal | number: '.2-2'" type="string"
              readonly>
          </mat-form-field>
        </div>

      </div>

      <div class="row">
        <div class="col-md-4">
          <mat-form-field>
            <span class="matPrefixDisabled" matPrefix>$&nbsp;</span>
            <input matInput placeholder="Importe del Préstamo:" [value]="pendingLoanTotal | number: '.2-2'"
              type="string" readonly>
          </mat-form-field>
        </div>
        <div class="col-md-4">
          <mat-form-field>
            <span class="matPrefixDisabled" matPrefix>$&nbsp;</span>
            <input matInput placeholder="Intereses por Pronto Pago:" [value]="prepaymentInterest | number: '.2-2'"
              type="string" readonly>
          </mat-form-field>
        </div>
        <div class="col-md-4">
          <mat-form-field>
            <span class="matPrefixDisabled" matPrefix>$&nbsp;</span>
            <input matInput placeholder="Monto a Retirar de la Caja De ahorro:"
              [ngModel]="withdraw.amountToWithdraw | number: '1.'"
              (ngModelChange)="withdraw.amountToWithdraw=currencyInputChanged($event)" appOnlyNumber
              [allowDecimals]="true" [allowSign]="false" type="string">
          </mat-form-field>
        </div>
      </div>

    </div>


    <div class="row">
      <div class="col-md-4 offset-md-4">
        <!-- TODO mostrar confirmación antes de cancelar -->
        <button class="btn btn-block btn-outline-secondary" (click)="cancel(0, null)">Cancelar</button>
      </div>
      <div class="col-md-4">
        <!-- TODO Mostrar Confirmación -->
        <button class="btn btn-block btn-primary" (click)="savePartialWithdraw()">Retirar</button>
      </div>
    </div>

  </div>
</div>
<ng-template #regresar>
  <div class="row mt-4">
    <div class="col-md-12 text-center noActions">
      <mat-icon aria-hidden="true">priority_high</mat-icon>
      <h5>Revisando acumulados.</h5>
      <h5>No es posible Retirar el saldo de tu caja de ahorro.</h5>
    </div>
  </div>
</ng-template>